import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltAutocompleteChipTooltipDescriptionWireframe from './VeltAutocompleteChipTooltipDescriptionWireframe/VeltAutocompleteChipTooltipDescriptionWireframe';
import VeltAutocompleteChipTooltipIconWireframe from './VeltAutocompleteChipTooltipIconWireframe/VeltAutocompleteChipTooltipIconWireframe';
import VeltAutocompleteChipTooltipNameWireframe from './VeltAutocompleteChipTooltipNameWireframe/VeltAutocompleteChipTooltipNameWireframe';
var VeltAutocompleteChipTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-wireframe", __assign({}, transformedProps), children));
};
VeltAutocompleteChipTooltipWireframe.Description = VeltAutocompleteChipTooltipDescriptionWireframe;
VeltAutocompleteChipTooltipWireframe.Icon = VeltAutocompleteChipTooltipIconWireframe;
VeltAutocompleteChipTooltipWireframe.Name = VeltAutocompleteChipTooltipNameWireframe;
export default VeltAutocompleteChipTooltipWireframe;
